import React from 'react';
import styles from './HouseSvg.scss';
import HouseSvgImage from '../../assets/img/ValHouse.svg';
import { ISubcode } from './ValuationWidget';

export interface IHouseSvgProps {
    variant: 'house' | ISubcode;
    align?: 'center' | 'left';
}

const HouseSvg: React.FC<React.PropsWithChildren<IHouseSvgProps>> = ({ variant = null, align = 'center' }) => {
    return (
        <div className={[styles.houseSvg, styles[variant], styles[align]].filter((e) => e).join(' ')}>
            <HouseSvgImage />
        </div>
    );
};

export default HouseSvg;
